'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const LogoDecathlonFaviconAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 32,
          height: 32,
          transform: "translate(0.199951)",
          fill: "#3643BA"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#clip0_2953_3150)", children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M21.7507 6.49097C13.9752 6.49097 4.30334 14.5359 4.30334 21.2034C4.30334 24.647 6.94839 26.3837 10.4419 26.3837C13.0071 26.3837 16.1112 25.4455 19.1056 23.6389V10.3338C18.3071 11.7012 14.5542 17.2109 11.5398 20.1454C10.0027 21.6426 8.78495 22.2914 7.73691 22.2914C6.55912 22.2914 6.00017 21.4929 6.00017 20.3051C6.00017 14.9152 15.0732 7.90831 21.0819 7.90831C23.5573 7.90831 25.1543 9.00626 25.1543 11.1423C25.1543 13.0986 23.8268 15.554 21.5611 17.8198V21.9421C25.5137 18.8179 27.8792 14.8354 27.8792 11.6214C27.8792 8.2377 25.2442 6.49097 21.7507 6.49097Z",
          fill: "white"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_2953_3150", children: /* @__PURE__ */ jsx(
        "rect",
        {
          width: 24.0371,
          height: 19.8928,
          fill: "white",
          transform: "translate(4.20398 6.49097)"
        }
      ) }) })
    ]
  }
);
const VpLogoDecathlonFaviconAsset = forwardRef(LogoDecathlonFaviconAsset);

export { VpLogoDecathlonFaviconAsset as default };
